import React from "react";
import "./style.css";
import LinkToCollection from "../LinkToCollection/LinkToCollection.js";
import OrderedImagesList from "../../../../../../merchant/panel/components/orderedImagesList/orderedImagesList.js";
export default function OrderInfo(props) {
    const { orderId, order } = props;
    return (React.createElement("div", { className: "order-info-container" },
        React.createElement("strong", null, "Id zam\u00F3wienia:"),
        " ",
        orderId,
        React.createElement("br", null),
        React.createElement("strong", null, "Na imi\u0119 i nazwisko:"),
        " ",
        order.name,
        React.createElement("br", null),
        React.createElement("strong", null, "Kwota:"),
        " ",
        order.price,
        " z\u0142",
        React.createElement("br", null),
        React.createElement("strong", null, "Metoda p\u0142atno\u015Bci:"),
        " ",
        order.paymentMethod == "cash" ?
            "Przy odbiorze"
            : order.paymentMethod == "electronic" ?
                "Elektronicznie"
                : "Nie wybrano",
        React.createElement("br", null),
        React.createElement("strong", null, "Stan P\u0142atno\u015Bci:"),
        " ",
        order.paymentState == "while_ordering" ?
            "W trakcie zamawiania"
            : order.paymentState == "waiting_for_payment" ?
                "Oczekuje na płatność"
                : order.paymentState == "payed" && order.paymentMethod == "cash" ?
                    "Przy odbiorze"
                    : "Opłacona",
        React.createElement("br", null),
        order.paymentState === "payed" && order.isConnectedWithCollection && (React.createElement(LinkToCollection, { orderId: orderId, orderKey: props.orderKey })),
        React.createElement(OrderedImagesList, { order: {
                orders: order.items.map((item) => ({
                    ...item,
                    offerName: item.label,
                    orderedFormats: item.orderedFormats,
                })),
                oneTimeOrders: order.oneTimeItems,
            } })));
}
